import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  public _UserService = environment.UserService;
  public _httpOptions;
  public sessionId: string
  constructor(private http: HttpClient) {
    // this.sessionId = sessionStorage["SessionId"]
    // console.log("bhhhb",this.sessionId)
    // this._httpOptions = {
    //   headers: new HttpHeaders({ 'SessionId':this.sessionId })
    // };
  }

  // ,sessionID:string
  GetUserAccessRightsDetails(customer: object, sessionID: string) {
    // console.log("hjhjhj",sessionID)
    var httpOptions = {
      headers: new HttpHeaders({ 'SessionId': sessionID })
    };
    var Query = this._UserService;
    // console.log("access", Query);
    return this.http.post<{ data: any }>(Query, customer, httpOptions);
  }
  GetUserAccessRightsDetailsinMailLink(logId:string, sessionID_: string) {
    //logId = logId.replace(' ','+')
    logId = logId.replace('/','ZZZZZZZZZ')
     //console.log("hjhjhj",sessionID_)
    var httpOptions = {
      headers: new HttpHeaders({ 'SessionId': sessionID_ })
    };
    var Query = this._UserService+'/GetUserAccessRightsDetailsinMailLink/'+logId;
    console.log("access", Query);
    return this.http.get<{ data: any }>(Query, httpOptions);
  }
  Logout(user: object) {
    var sessionID = sessionStorage["SessionId"]
    var httpOptions = {
      headers: new HttpHeaders({ 'SessionId': sessionID })
    };
    var Query = this._UserService + '/Logout';
    return this.http.post<{ data: any }>(Query, user, httpOptions);
  }
}
